import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import fetch_45profile_45global from "/opt/build/repo/middleware/fetch-profile.global.ts";
import requires_45admin_45global from "/opt/build/repo/middleware/requires-admin.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  fetch_45profile_45global,
  requires_45admin_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "one-session-per-user": () => import("/opt/build/repo/middleware/one-session-per-user.ts"),
  "redirect-if-logged-in": () => import("/opt/build/repo/middleware/redirect-if-logged-in.ts"),
  "requires-membership": () => import("/opt/build/repo/middleware/requires-membership.ts")
}